import { useContext, useEffect, useState } from "react";
import { SelectableTextContext, WebEditorContext } from "../../../../contexts";
import GenericSidebar from "../../../../components/Modals/genericSidebar";
import SelectableTextComponent from "./selectableTextComponent";
import * as Constants from "../../../../utils/constants"
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function SelectableTextOverlapSideBar() {
    const { selectedTextPartIdRef } = useContext(SelectableTextContext);
    const { editorFileRef, handleActionMenuBar, sideBarState, setSideBarState } = useContext(WebEditorContext);
    const largeMatch = useMediaQuery('(min-width: 1024px)');
    const [open, setOpen] = useState(sideBarState === Constants.sideBarState.predefinedTexts && !largeMatch);
    const { t: te } = useTranslation([resources.edit]);

    useEffect(() => {
        if (largeMatch && sideBarState === Constants.sideBarState.predefinedTexts) {
            setOpen(false);
        }
        if (!largeMatch && sideBarState === Constants.sideBarState.predefinedTexts) {
            setOpen(true);
        }
    }, [largeMatch]);

    const handleOpen = (value) => {
        if (!value) {
            selectedTextPartIdRef.current = null;
            handleActionMenuBar({
                editorFile: editorFileRef.current,
                actionMenuBar: {
                    selectableTextState: Constants.normalState,
                },
            })
        }

        setOpen(value)
        if (value) {
            setSideBarState(Constants.sideBarState.predefinedTexts);
        } else {
            setSideBarState(Constants.sideBarState.closed);
        }
    }

    return (
        <GenericSidebar
            open={open}
            setOpen={handleOpen}
            onClose={() => handleOpen(false)}
            title={te(translations.edit.predefined.predefinedText)}
        >
            <div className="tw-h-full tw-w-full">
                <div className="tw-px-4 tw-py-4">
                    <SelectableTextComponent inSidebarDialog={true} />
                </div>
            </div>
        </GenericSidebar>

    )

}